import React from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

const ErrorBoundary: React.FC = () => {
  const { t } = useTranslation();
  const error = useRouteError() as any;

  return (
    <div className="container">
      <div className="section">
        <div className="columns is-centered">
          <div className="column is-half">
            <div className="box has-text-centered">
              <h1 className="title is-4 has-text-danger">{t("errors.somethingWrong")}</h1>
              <p className="subtitle is-6">
                {error?.statusText || error?.message || t("errors.unexpectedError")}
              </p>
              {error?.status && (
                <p className="has-text-grey">{t("errors.status", { status: error.status })}</p>
              )}
              <div className="mt-4">
                <button
                  className="button is-primary"
                  onClick={() => window.location.href = "/"}
                >
                  {t("errors.goHome")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
